// Basic types
export type CadenceType = 'NINETY_DAYS' | 'GO_WITH_BOX';
export enum CADENCE_TYPE {
  NINETY_DAYS = 'NINETY_DAYS',
  GO_WITH_BOX = 'GO_WITH_BOX',
}

// Product-related interfaces
interface Variant {
  id: number;
  productId: number;
  imageUrl: string;
  sku: string;
  description: string;
  sizeInfo: string | null;
  availableInventory: number;
  replenishmentPrice: number;
  retailPrice: number;
  subscriptionsLimit: number;
  displayOrder: number;
  deleted: boolean;
  shippingRestrictions: string[] | null;
  nextVariantInChain: number | null;
  replacementVariantId: number | null;
  psProductId: number;
}

export interface Product {
  id: number;
  name: string;
  brand: string;
  slug: string;
  variants: Variant[];
  psProductId: number;
}

// Subscription-related interfaces

interface Subscription {
  variantId: number;
  campaignId: number | null;
  quantity: number;
  quantityChange: number | null;
  billedQuantityChange: number | null;
  sku: string | null;
  cadenceType: CadenceType;
  liveInCampaignType: string;
  nextRenewalDate: string | null;
  billDate: string | null;
}

interface SubscriptionItem {
  availableSubscriptions: number;
  subscriptionTotal: number;
  product: Product;
  subscription: Subscription;
}

interface CadenceDetails {
  cadenceType: CadenceType;
  shippingFeeInCents: number;
  processingFeeInCents: number;
  subtotalInCents: number;
  nextRenewalDate: string;
  nextRenewalSeason: string | null;
  subscriptions: SubscriptionItem[];
}

export interface SubscriptionData {
  NINETY_DAYS?: CadenceDetails;
  GO_WITH_BOX?: CadenceDetails;
}

export interface ProductsSelfData {
  activeProductSubscriptions: SubscriptionData;
}
